import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { Environment, ModelNumStr, PittogrammiGruppo, PittogrammiGruppoLng } from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class PittogrammiGruppoService extends CrudGenericsService<PittogrammiGruppo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/PittogrammiGruppo`);
    this.base = `${env.apiUrl}/api/PittogrammiGruppo/`;
  }

  GetAllLng(): Observable<PittogrammiGruppoLng[]> {
    const u = `${this.base}GetAllLng`;
    return this.http.get<PittogrammiGruppoLng[]>(u);
  }

  SetOrder(model: ModelNumStr[]): Observable<void> {
    const u = `${this.base}SetOrder`;
    return this.http.post<void>(u, model).pipe(take(1));
  }
}
